import { useEffect, useState } from "react";
import { useInView } from "@/hooks/useInView";

export default function CountUp({
  end,
  duration = 1600,
  prefix = "",
  suffix = "",
  decimals = 0,
  className = "",
  format = null,
}) {
  const [val, setVal] = useState(0);
  const { ref, inView } = useInView({ threshold: 0.3, once: true });

  useEffect(() => {
    if (!inView) return;
    let raf = 0;
    let start = null;
    const step = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(end * eased);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, end, duration]);

  const formatted = format
    ? format(val)
    : `${prefix}${val.toFixed(decimals)}${suffix}`;

  return (
    <span ref={ref} className={className} data-testid="count-up">
      {formatted}
    </span>
  );
}
